import React from "react";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../../Shared/helpers/currency";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

export const CartListComponent = ({ cartProducts, updateCart }) => {
  return cartProducts.map(({ product }, key) => (
    <CartItemComponent
      key={`product-${key}`}
      index={key}
      product={product}
      updateCart={updateCart}
    />
  ));
};

export const CartItemComponent = ({ product, index, updateCart }) => {
  const { t } = useTranslation();

  let price = product.price;

  if (product.type === "bundle" || product.type === "grouped") {
    price = product.bundle.reduce((carry, item) => {
      if ("variable" === item.product.type && item.product.variation) {
        return carry + parseFloat(item.product.variation.regular_price);
      } else {
        return carry + parseFloat(item.product.price);
      }
    }, 0);
  }

  const isVariable = product.type === "variable" && product.variation;
  const isGrouped = (product.type === "bundle" || product.type === "grouped") && product.bundle;

  return (
    <div className="card p-3 mb-2">
      <div className="d-flex justify-content-between align-items-start">
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <span className="badge bg-dark rounded-pill">
              {product.quantity}x
            </span>
            <span className="fw-medium">{t(product.name)}</span>
          </div>

          {isVariable && (
            <div className="small text-muted mt-1 ps-1">
              {t(product.variation.name.replace(product.name + " - ", "").replace(product.name + " ", ""))}
            </div>
          )}

          {isGrouped && (
            <div className="mt-2 ps-1">
              {product.bundle.map(({ product: bp }, idx) => (
                <div key={`bundle-${idx}`} className="d-flex justify-content-between small text-muted py-1">
                  <span>
                    {bp.type === "variable" && bp.variation
                      ? t(bp.name)
                      : t(bp.name)}
                    {bp.type === "variable" && bp.variation && (
                      <span className="text-muted">
                        {" · "}{t(bp.variation.name.replace(bp.name + " - ", "").replace(bp.name + " ", ""))}
                      </span>
                    )}
                  </span>
                  <span>
                    {bp.type === "variable" && bp.variation
                      ? formatCurrency(bp.variation.regular_price)
                      : formatCurrency(bp.price)}
                  </span>
                </div>
              ))}
            </div>
          )}

          {product.answers && product.answers.length > 0 && (
            <div className="small text-muted mt-2">
              {product.answers.map(({ question, value }, attrkey) => (
                <div key={`attr-${index}-${attrkey}`}>
                  {t(question)}: {value}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="d-flex flex-column align-items-end ms-3">
          <span className="fw-bold mb-2">
            {formatCurrency(price * product.quantity)}
          </span>
          <div className="d-flex gap-1">
            <span
              role="button"
              onClick={() => updateCart(index, "reduce")}
              style={{ cursor: "pointer", color: "var(--tws-brown)" }}
            >
              <FiMinusCircle size={20} />
            </span>
            <span
              role="button"
              onClick={() => updateCart(index)}
              style={{ cursor: "pointer", color: "var(--tws-brown)" }}
            >
              <FiPlusCircle size={20} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
